import React, { ChangeEventHandler } from 'react';
import { Button, Checkbox } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';
import { useAsyncState } from '@/utils/hooks';
import { ExportColumnDefinition, getInvoiceExportColumns, InvoiceExportOptions } from '@/services/order-export';
import { ExportColumnSelection } from './ExportColumnSelection';

export interface InvoiceExportConfigurationProps {
    value: InvoiceExportOptions;
    onChange(newValue: InvoiceExportOptions): void;
}

function getDefaultOptions(columns: ExportColumnDefinition[] | null): InvoiceExportOptions {
    return {
        columns: columns ? columns.filter((x) => x.isDefault).map((x) => x.key) : [],
    };
}

export const InvoiceExportConfiguration: React.FC<InvoiceExportConfigurationProps> = ({ value, onChange }) => {
    const [columns] = useAsyncState(() => getInvoiceExportColumns(), [], null);
    const fixedValue: InvoiceExportOptions = {
        ...getDefaultOptions(columns),
        ...value,
    };

    const handleChange = (changes: Partial<InvoiceExportOptions>) => {
        onChange({ ...fixedValue, ...changes });
    };

    const resetToDefaults = () => {
        onChange(getDefaultOptions(columns));
    };

    if (!columns) {
        return null;
    }

    return (
        <div>
            <ExportColumnSelection
                value={fixedValue.columns}
                onChange={(newValue) => handleChange({ columns: newValue })}
                columns={columns}
            />

            <Button variant="primary" onClick={resetToDefaults}>
                <Trans>Reset to default</Trans>
            </Button>
        </div>
    );
};
